import { useQuery } from "@apollo/client/react";

import { GetMyPreferencesDocument } from "#app/lib/data";

/**
 * The viewer's standing answer to "open a detail with its empty property
 * rows shown?" — the `showEmptyProperties` preference. Null (never set)
 * folds, which is the shipped default: a blank row is not information.
 *
 * Cache-first: the network fetch is owned by `workspace-data-provider`, so
 * this is a read of the same entry, never a second request.
 */
export function useShowEmptyProperties(): boolean {
  const { data } = useQuery(GetMyPreferencesDocument, { fetchPolicy: "cache-first" });
  return data?.myPreferences?.showEmptyProperties === true;
}
